import EInvoiceRoutingSettings from '../integration-settings/EInvoiceRoutingSettings';
export default function EInvoiceRoutingSettingsPage(){return <div className="p-4"><EInvoiceRoutingSettings/></div>;}
